<template>
    <div class="administration-round-list-container">
        <div v-if="this.displayMhrModal == true">
            <MyHealthRecorModal :actionTitle="actionTitle" :loading="loading" :actionDescription="description"
                @action="handleAction" @close="closeModal" :errorMessage="errorMessage"
                :additionalFilterStatus="additionalFilterStatus" :removeFile="removeFileStatus"
                :acceptText="acceptText" :hideCancel="hideCancel" />
        </div>
        <div class="filters"
            style="width: 100%; margin-top: 0; padding-top: 10px;padding-top: 25px;padding-bottom: 20px;">
            <!-- <h3 style="color: black; text-align: left; margin: 20px 0 0 50px; padding: 0; font-size: 15px;">
                File Search
            </h3>
            <div>
                <div style="display: flex; gap: 5px; align-items: center;" class="administrations-search">
                    <div style="margin: 0 0 0 30px;">
                        <InputText v-model="searchTerm" style="width: 15em;  background-color: white; opacity: 1 "
                            placeholder="Search For File" v-on:keyup.enter="searchForResident(false)" />
                    </div>
                </div>
            </div> -->
            <h3 style="color: black; text-align: left; margin: 20px 0px 0px 50px; padding: 0px; font-size: 15px;">
                File Filter
            </h3>
            <div>
                <div style="display: flex; gap: 0px; align-items: center;  margin: 0 0 0 30px;"
                    class="administrations-search">
                    <Button @click="setSearchType('view')" style="width: fit-content;"
                        class="outline-button p-button-outlined" label="View Type"
                        :style="searchType === 'view' ? 'background-color: #007BFF; color: white !important;' : 'background-color: #ffffff; color: grey !important;'" />
                    <Button @click="setSearchType('file')" style="width: fit-content;"
                        class="outline-button p-button-outlined" label="File Type"
                        :style="searchType === 'file' ? 'background-color: #007BFF; color: white !important;' : 'background-color: #ffffff; color: grey !important;'" />
                </div>
            </div>
            <h3 style="color: black; text-align: left; margin: 20px 0 0 50px; padding: 0px; font-size: 15px;">
                {{ searchType === 'view' ? 'View Type' : 'File Type' }}
            </h3>
            <div>
                <div style="display: flex; gap: 5px; align-items: center;  margin: 0 0 0 30px;"
                    class="administrations-search">
                    <div v-if="searchType === 'view'">
                        <div class="select-filters-container" style="height: 35px;">
                            <Dropdown class="admin-rooms-dropdown" v-model="selectedOption" :options="viewOptions"
                                optionLabel="name" placeholder="Select Type"
                                style="position: relative; min-width: 15em;margin-right: 0px !important" />
                        </div>
                    </div>

                    <div v-else>
                        <div class="select-filters-container" style="height: 35px;">
                            <Dropdown class="admin-rooms-dropdown" v-model="selectedOption" :options="fileOptions"
                                optionLabel="name" placeholder="Select Type"
                                style="position: relative; min-width: 15em;margin-right: 0px !important" />
                        </div>
                    </div>

                </div>
            </div>

            <div style="display: flex; gap: 5px; align-items: center; margin: 20px 0 0 30px;"
                class="administrations-search">
                <Button @click="searchFile" style="width: fit-content; margin-right: 1em;" class="green-button white"
                    label="Search" />
                <Button @click="openAdditionalFilter" style="width: fit-content; margin-right: 1em;"
                    class="black-button" label="Additional Filter" />
            </div>
        </div>
        <div>
            <h3 style="
              color: #ffff; 
              border: 2px solid #9F5CC0; /* Border color and thickness */ 
              background-color: #9F5CC0;  /* Background color */ 
              border-top-left-radius: 12px; /* Rounded top-left corner */ 
              border-top-right-radius: 12px; /* Rounded top-right corner */ 
              padding: 10px; /* Padding inside the element */
              box-sizing: border-box; /* Include border and padding in total width and height */
            ">
                Files List
            </h3>
            <div class="files-list-results" ref="scrollContainer">
                <div>
                    <!-- Vertical list of files -->
                    <div>
                        <ul v-if="this.fileLoading">
                            <i class="pi pi-spin pi-spinner"
                                style="font-size: 2rem !important; margin-top: 10px; margin-bottom: 10px;">
                            </i>
                        </ul>
                        <ul v-else-if="this.files.length == 0 && searchType !== 'view'">
                            No files found !
                        </ul>
                        <ul v-else style="list-style-type: none; padding: 0;">
                            <li v-for="file in this.files" :key="file.documentId" @click="getFile(file)"
                                style="cursor: pointer; border: 1px solid #ddd; border-radius: 4px;" :style="{
                                    backgroundColor: file === selectedFile ? '#f0f0f0' : '#ffffff', // Darker shade when selected
                                }">
                                <div style="">
                                    <div>
                                        <div
                                            style="display: flex; gap: 50px; align-items: center; color: #000; padding: 20px 10px; font-weight: bold;">
                                            <span
                                                style=" color: #007BFF; padding: 2px 6px; border-radius: 4px; font-weight: bold;">
                                                {{ file.authorInstitution.organizationName }}
                                            </span>
                                            <span style=" color: black; font-weight: bold;">
                                                {{ file.serviceStartTime }}
                                            </span>
                                        </div>

                                        <div
                                            style="display: flex; align-items: center; color: #000; padding: 10px 10px; font-weight: bold;">
                                            <span style=" color: #000; padding: 0 6px; font-weight: bold; ">
                                                {{ file.type.displayName }}
                                            </span>
                                        </div>

                                        <div
                                            style="display: flex; gap: 50px; align-items: center; color: #000; padding: 20px 10px; font-weight: bold;">
                                            <!-- Removed due to "recommendation" of the Agency -->
                                            <!-- <span
                                                style="background-color: #9F5CC0; color: #ffffff; padding: 2px 6px; border-radius: 4px; font-size: 12px;">
                                                {{ file.type.displayName }}
                                            </span> -->
                                            <button
                                                v-if="file === selectedFile && file.type.displayName === 'Residential Care Medication Chart'"
                                                @click.stop="removeFilePermission()"
                                                style="background-color: red; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; margin-left: 100px !important">
                                                <!-- Trash bin icon SVG -->
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3 6H5H21" stroke="white" stroke-width="2"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path
                                                        d="M8 6V4C8 3.44772 8.44772 3 9 3H15C15.5523 3 16 3.44772 16 4V6M19 6V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V6H19ZM9 10V16"
                                                        stroke="white" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M13 10V16" stroke="white" stroke-width="2"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </button>
                                        </div>

                                    </div>

                                </div>
                            </li>
                        </ul>

                    </div>

                </div>

            </div>
        </div>
        <!-- <div v-if="currentPage < page_count">
            <p style="font-size: 1em;">Scroll down to view more residents</p>
            <p><span class="pi pi-chevron-down"></span></p>
        </div> -->
    </div>
</template>

<script>
import axios from 'axios';
import MyHealthRecorModal from '../modals/MyHealthRecorModal.vue';
export default {
    components: {
        MyHealthRecorModal
    },
    // props: ['patient',files],
    props: ['patient', 'files', 'fileLoading'],
    data() {
        return {
            acceptText: '',
            removeFileStatus: false,
            dateFilter: null,
            actionTitle: '',
            additionalFilterStatus: false,
            displayMhrModal: false,
            hideCancel: false,
            accepted: false,
            description: '',
            loading: false,
            errorMessage: '',
            selectedFile: '',
            searchType: '',
            selectedOption: null, // Default selected option
            fileOptions: //['Discharge Summary', 'Residental Care Medication Chart', 'Pathology Reports', 'Shared Health Summary', 'Pharmacist Shared Medicines', 'Specialist Letters', 'Prescription Records', 'Diagnostic Imaging Reports'],
                [
                    // {
                    //   name: 'Current - (-1hr) - (+3hrs)',
                    //   value: ''
                    // },
                    // {
                    //     name: 'All',
                    //     window: 23340000,
                    // },
                    {
                        name: 'All',
                        window: 23340000,
                        type: null,
                        class: null
                    },
                    {
                        name: 'Discharge Summary',
                        window: 23340000,
                        type: '18842-5^^LOINC',
                        class: '1.2.36.1.2001.1006.1.20000.18^^LOINC'
                    },
                    {
                        name: 'Residential Care Medication Chart',
                        window: 12540000,
                        type: '100.32046^^NCTIS Data Components',
                        class: '1.2.36.1.2001.1006.1.32046.2^^LOINC'
                    },
                    {
                        name: 'Residential Care Transfer Overview',
                        window: 12540000,
                        type: '100.32047^^NCTIS Data Components',
                        class: '2.16.840.1.113883.6.1^^LOINC'
                    },
                    {
                        name: 'Shared Health Summary',
                        window: 10740000,
                        value: ' 10:00:00 GMT+1000 (Australian Eastern Standard Time)'
                    },
                    {
                        name: 'Medical Conditions View',
                        window: 23340000,
                        type: '100.32002.1^^NCTIS Data Components',
                        class: '1.2.36.1.2001.1005.59^^NCTIS Data Components'
                    },
                    // {
                    //     name: 'Pharmacist Shared Medicines',
                    //     window: 7140000,
                    //     value: ' 13:00:00 GMT+1000 (Australian Eastern Standard Time)'
                    // },
                    {
                        name: 'Specialist Letters',
                        window: 14340000,
                        type: '51852-2^^LOINC',
                        class: '1.2.36.1.2001.1006.1.16615.28^^LOINC'
                    },
                    // {
                    //     name: 'Prescription Records',
                    //     window: 7140000,
                    //     value: ' 19:00:00 GMT+1000 (Australian Eastern Standard Time)'
                    // },
                    {
                        name: 'Diagnostic Imaging Reports',
                        window: 10740000,
                        value: ' 21:00:00 GMT+1000 (Australian Eastern Standard Time)'
                    },
                    {
                        name: 'Residential Care Health Summary',
                        window: 7140000,
                        type: '100.32049^^NCTIS Data Components',
                        class: '1.2.36.1.2001.1006.1.32049.2^^NCTIS Data Components'
                    },
                    {
                        name: 'Residential Care Transfer Reason',
                        window: 23340000,
                        type: '100.32047^^NCTIS Data Components',
                        class: '1.2.36.1.2001.1005.82^^LOINC'
                    },
                    // {
                    //     name: 'MyMedicare Registered Practice Information',
                    //     window: 23340000,
                    //     type: '100.32048^^NCTIS Data Components',
                    //     class: '1.2.36.1.2001.1005.81^^NCTIS Data Components'
                    // },
                    {
                        name: 'Immunisation Consolidated View',
                        window: 23340000,
                        type: '100.32034^^NCTIS Data Components',
                        class: '1.2.36.1.2001.1005.77^^NCTIS Data Components'
                    },
                    // {
                    //     name: 'Medicines View',
                    //     window: 23340000,
                    //     type: '100.32002.1^^NCTIS Data Components',
                    //     class: '1.2.36.1.2001.1005.59^^NCTIS Data Components'
                    // },
                ],
            viewOptions: // ['Resident Care Transfer Overview', 'Prescriptions & Dispensing', 'Observations'],
                [
                    // {
                    //   name: 'Current - (-1hr) - (+3hrs)',
                    //   value: ''
                    // },
                    // {
                    //     name: 'Resident Care Transfer Overview',
                    //     window: 23340000,
                    //     type: '100.32047^^NCTIS Data Components',
                    //     class: '1.2.36.1.2001.1005.82^^LOINC'
                    // },
                    // {
                    //     name: 'Medicare Overview',
                    //     window: 10740000,
                    //     type: '100.16767.1^^NCTIS Data Components',
                    //     class: '1.2.36.1.2001.1006.1.172.1^^NCTIS Data Components'
                    // },
                    // {
                    //     name: 'Prescriptions & Dispensing',
                    //     window: 12540000,
                    //     value: ' 06:30:00 GMT+1000 (Australian Eastern Standard Time)'
                    // },
                    // {
                    //     name: 'Observations',
                    //     window: 10740000,
                    //     value: ' 10:00:00 GMT+1000 (Australian Eastern Standard Time)'
                    // },
                    // {
                    //     name: 'Diagnostic Imaging Overview',
                    //     window: 23340000,
                    //     type: '100.32025^^NCTIS Data Components',
                    //     class: '1.2.36.1.2001.1005.76.2^^NCTIS Data Components'
                    // },
                    // {
                    //     name: 'Pathology Overview',
                    //     window: 23340000,
                    //     type: '100.32026^^NCTIS Data Components',
                    //     class: '1.2.36.1.2001.1005.76.1^^NCTIS Data Components'
                    // },
                    {
                        name: 'Medicare Overview',
                        window: 23340000,
                        type: 'medicare',
                        class: ''
                    },
                    {
                        name: 'Prescription and Dispense View',
                        window: 23340000,
                        type: 'pdv',
                        class: ''
                    },
                    {
                        name: 'Pathology Overview',
                        window: 23340000,
                        type: 'pathology',
                        class: ''
                    },
                    {
                        name: 'Diagnostic Imaging Overview',
                        window: 23340000,
                        type: 'diagnosticImaging',
                        class: ''
                    },
                    // {
                    //     name: 'Health Record Overview',
                    //     window: 23340000,
                    //     type: 'hro',
                    //     class: ''
                    // },

                ],
        }
    },
    methods: {
        closeModal() {
            this.displayMhrModal = false;
            this.actionTitle = '';
            this.actionDescription = '';
            this.description = '';
            this.additionalFilterStatus = false;
            this.removeFileStatus = false;
            this.errorMessage = '';
            this.hideCancel = false;
            this.accepted = false;
        },
        getFile(file) {
            this.selectedFile = file;
            file.type.identify = this.searchType;
            this.$emit('get-file', file);
            this.$emit('select-file', file);
        },
        removeFilePermission() {
            console.log("removing file activating");
            this.removeFileStatus = true;
            this.additionalFilterStatus = false;
            this.accepted = false;
            this.actionTitle = 'Confirm Action';
            this.acceptText = 'Confirm';
            this.description = 'Are you sure you would like to confirm action?';
            this.displayMhrModal = true;
        },
        removeFile() {
            this.loading = true;
            this.errorMessage = '';
            this.$emit('remove-file', this.selectedFile, (err, successMsg) => {
                this.loading = false;
                if (err) {
                    this.errorMessage = err;
                } else {
                    this.description = successMsg || 'Document is Successfully Removed';
                    this.actionTitle = 'Success';
                    this.acceptText = 'OK';
                    this.hideCancel = true;
                    this.accepted = true;
                    this.selectedFile = '';
                    this.searchFile(); // Callback after removal is handled
                }
            });
        },
        clearFilters() {
            this.searchTerm = '';
        },
        setSearchType(type) {
            console.log("setting search ", type);
            this.searchType = type;
        },
        selectOption() {
            this.selectedOption = event.target.value; // Handle change event
            console.log('Selected option:', this.selectedOption);
        },
        searchFile() {
            console.log('searching file');
            if (!this.searchType) {
                console.log("please selected file type first, ", this.searchType);
                return;
            }
            if (this.searchType === 'file') {
                console.log("getting file");
                let filter = {
                    ...this.selectedOption,
                    from: this.dateFilter?.from != null ? this.dateFilter.from : '',
                    to: this.dateFilter?.to != null ? this.dateFilter.to : '',
                    identify: this.searchType,
                };
                this.$emit('search-file', filter);
            } else if (this.searchType === 'view') {
                console.log("getting get-view");
                let filter = {
                    name: this.selectedOption.name,
                    type: this.selectedOption.type,
                    from: this.dateFilter?.from != null ? this.dateFilter.from : '',
                    to: this.dateFilter?.to != null ? this.dateFilter.to : '',
                };
                this.$emit('get-view', filter);
            }
            this.dateFilter = null;
        },
        openAdditionalFilter() {
            console.log("This is additional filter modal open .....");
            this.actionTitle = 'Additional Filters',
                this.acceptText = 'Apply Filters';
            this.additionalFilterStatus = true;
            this.displayMhrModal = true;
        },
        setDateFilter(actionData) {
            console.log("setting date filters ", actionData);
            this.dateFilter = {
                from: actionData.from,
                to: actionData.to
            };
            this.additionalFilterStatus = false;
            this.displayMhrModal = false;
        },
        handleAction(actionData) {
            console.log("action clicked !!!!!!!");
            if (this.additionalFilterStatus) {
                // this.searchFile(actionData);
                this.setDateFilter(actionData);
            } else if (this.removeFileStatus) {
                if (this.accepted) {
                    this.closeModal();
                } else {
                    this.removeFile();
                }
            } else {
                return;
            }
        }
    },
    mounted() {
        console.log("this is patient ", this.patient);
        this.searchType = 'file';
        this.searchFile();
        // Attach the scroll event listener to the specified element
        // this.$refs.scrollContainer.addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
        // Remove the scroll event listener when the component is destroyed
        console.log('unmounting the event listener');
        // this.$refs.scrollContainer.removeEventListener('scroll', this.handleScroll);
    },
    computed: {
    },
    watch: {
        // Directly watching Vuex state without using mapState or computed properties
        '$store.state.isUploadSuccessful'(newValue) {
            if (newValue === true) {
                console.log("searching file after reload ......");
                this.searchFile();

                // Reset the isUploadSuccessful state in Vuex to false
                this.$store.dispatch('triggerUploadSuccess', false);
            }
        },
        searchType: {
            immediate: true,
            handler(newSearchType) {
                if (newSearchType === 'view') {
                    this.selectedOption = this.viewOptions.length > 0 ? this.viewOptions[0] : null;
                } else {
                    this.selectedOption = this.fileOptions.length > 0 ? this.fileOptions[0] : null;
                }
            }
        },
    }
}
</script>

<style lang="scss">
.administration-round-list-container {
    background-color: #f3f4f4;
    border-radius: 8px;
    // height: fit-content;
    height: 75vh;
}

.administration-search-filters {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px;

}

.files-list-results {
    height: 50vh;
    overflow-y: auto;
}

.administration-round-item {

    padding: 10px 5px;
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #f3f4f4;

    h4 {
        text-align: left;
    }
}

.selected-round-item {
    background-color: rgba(8, 112, 220, 0.2);
}


.select-filters-container {
    p {
        font-size: 15px;
    }
}

.p-dropdown.admin-rooms-dropdown {
    background: #F3F4F4;
    border: none;
}
</style>